import React, { useEffect, useState } from 'react';
import { View,StyleSheet } from 'react-native';
import Iframe from 'react-iframe'

export default function valorprestacao({route,navigation}) {
  console.log(route)
    
  const [urlf, setUrlf] = useState([]);

  var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/indexvalidation.php';
  var headers={
   'Accept':'application/json',
   'Content-Type':'application.json',
   'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
   'Access-Control-Allow-Origin':'*',
   'crossDomain': 'true',
   'Host': 'https://emprestimoimperion.com/composer/controller/api/indexvalidation.php',
   'credentials': 'same-origin',
   'Access-Control-Allow-Credentials': 'true'
   
    };
   /*'crossDomain': 'true',*/
   var Data={
    id:route.params.userid,
    token:route.params.id,
    valor:route.params.valor,
    };

    fetch(validatinoApi,
    {
    method:'POST',
    headers:headers,
    body:JSON.stringify(Data)
    }).then((response)=>response.json())
    .then((response)=>{
    if(response.statusCode==200){   
    setUrlf('https://emprestimoimperion.com/composer/gerencianet/testegerencianet.php?id='+response.userid+'&token='+route.params.id+'&valor='+route.params.valor)
    }else{
    navigation.navigate('app',{id:response.sessionid,userid:response.userid})
    } 
    }).catch((error)=>{
    alert(error);
    });
    
























  return (
    <View style={{ flex: 1,
      backgroundColor: '#01150E',
      alignItems: 'center',
      justifyContent: 'center', }}>
     <Iframe url={urlf}
        width="100%"
        height="100%"
        id="myId"
        className="myClassname"
        display="initial"
        position="relative"
        frameBorder="0"
        style={{width:'100%',borderBottomWidth:0}
        }/>

  </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#01150E',
    alignItems: 'center',
    justifyContent: 'center',
    
  },
});